import { DefaultService } from '@/services/DefaultService';

export default class FiltroCockpitService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    save(filtros, modulo) {
        return this._http.post(`${this._env}/filtro-cockpit/filters/${modulo}`, filtros, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    buscarGraficosComFiltros(modulo) {
        return this._http.get(encodeURI(`${this._env}/filtro-cockpit/filters/${modulo}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
}